import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import { getAttendeesPainText } from "@clockwise/client-commons/src/util/scheduling-slot";
import { ResponseStatusEnum } from "@clockwise/schema";
import { AttendeesPains } from "@clockwise/web-commons/src/components/attendees-pains/AttendeesPains";
import React from "react";

import {
  EventSchedulingQueryEvent,
  EventSchedulingQueryOrg,
  EventSchedulingQueryPerson,
  getOrderedAttendeesAndPersonsMaps,
} from "./EventScheduling";

const AttendeesSlotPainsSummary = ({
  org,
  event,
  persons,
}: {
  org: EventSchedulingQueryOrg | null | undefined;
  event: EventSchedulingQueryEvent | undefined;
  persons: EventSchedulingQueryPerson[];
}) => {
  if (!org || !event) {
    return null;
  }
  const computeCurrentSlotImpactErrorable = getValue(org.computeCurrentSlotImpactErrorable);
  if (!computeCurrentSlotImpactErrorable) {
    return null;
  }

  const currentSlot = getValue(computeCurrentSlotImpactErrorable?.currentSlot);

  const { attendeeMap } = getOrderedAttendeesAndPersonsMaps({
    org: org,
    event,
  });

  // The BE always returns conflicts even for attendees who have declined a meeting
  // but we want to render pains only when attendees have not declined
  // Thus manually strip out the conflict data for any declined attendees here before generating pains text
  const currentSlotWithoutConflictFromAttendeesWhoHaveDeclined = {
    ...currentSlot,
    attendanceImpacts:
      currentSlot?.attendanceImpacts.filter(
        (ai) => attendeeMap[ai.calendarId]?.responseStatus != ResponseStatusEnum.Declined,
      ) || [],
    summary: {
      ...currentSlot?.summary,
      conflictingAttendees:
        currentSlot?.summary?.conflictingAttendees?.filter(
          (calendarId) => attendeeMap[calendarId]?.responseStatus != ResponseStatusEnum.Declined,
        ) || [],
    },
  } as typeof currentSlot;

  const pains =
    currentSlotWithoutConflictFromAttendeesWhoHaveDeclined && persons
      ? getAttendeesPainText(currentSlotWithoutConflictFromAttendeesWhoHaveDeclined, persons, true)
      : [];

  return <AttendeesPains pains={pains} />;
};

export default AttendeesSlotPainsSummary;
